var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "SearchIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5F62\u72B6\u7ED3\u5408") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.141176 0 0 0 0 0.145098 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Serving\\u9879\\u76EE\\uFF08\\u9879\\u76EE\\u7BA1\\u7406\\uFF09",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.\\u9879\\u76EE\\u7BA1\\u7406-\\u4E2A\\u4EBA\\u4E2D\\u5FC3",
    transform: "translate(-1363.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab",
    transform: "translate(40.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17\\u5907\\u4EFD-5",
    transform: "translate(1108.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(212.000000, 41.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.45454545,3 C11.4670077,3 13.9090909,5.44208318 13.9090909,8.45454545 C13.9090909,9.79699914 13.4241198,11.0261818 12.6198196,11.9764514 L14.838428,14.0932681 C15.0323174,14.2783872 15.0548934,14.6036947 14.888853,14.8198627 C14.7228126,15.0360308 14.4310319,15.0612009 14.2371426,14.8760818 L11.9211047,12.6660434 C10.9786798,13.4426642 9.7710825,13.9090909 8.45454545,13.9090909 C5.44208318,13.9090909 3,11.4670077 3,8.45454545 C3,5.44208318 5.44208318,3 8.45454545,3 Z M8.45454545,4.09090909 C6.04457564,4.09090909 4.09090909,6.04457564 4.09090909,8.45454545 C4.09090909,10.8645153 6.04457564,12.8181818 8.45454545,12.8181818 C10.8645153,12.8181818 12.8181818,10.8645153 12.8181818,8.45454545 C12.8181818,6.04457564 10.8645153,4.09090909 8.45454545,4.09090909 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#BFBFBF",
    fillRule: "nonzero"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.f43481eb.svg";
export { ForwardRef as ReactComponent };